import i18n, { i18n as i18nApi } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import {
  DEFAULT_LANGUAGE,
  DEFAULT_NAME_SPACE,
  KEY_SEPARATOR,
  nameSpaceNames,
  resources,
} from '../locales';

export const initI18n = (locale?: string): i18nApi => {
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      ns: nameSpaceNames,
      defaultNS: DEFAULT_NAME_SPACE,
      lng: locale,
      resources,
      // if you don't have plural polyfill installed already
      compatibilityJSON: 'v4',
      fallbackLng: DEFAULT_LANGUAGE,
      keySeparator: KEY_SEPARATOR,
      // optional : used to avoid character codes in texts -> user values have to be escaped manually to mitigate XSS attacks
      interpolation: { escapeValue: false },
      debug: import.meta.env.MODE === 'development',
    })
    .catch(console.error);
  return i18n;
};
